import { render, staticRenderFns } from "./proceedingsResult.vue?vue&type=template&id=37b554ae"
import script from "./proceedingsResult.vue?vue&type=script&lang=js"
export * from "./proceedingsResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b554ae')) {
      api.createRecord('37b554ae', component.options)
    } else {
      api.reload('37b554ae', component.options)
    }
    module.hot.accept("./proceedingsResult.vue?vue&type=template&id=37b554ae", function () {
      api.rerender('37b554ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/osh/proceedingsResult.vue"
export default component.exports